import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { DEFAULT_TIME_ZONE_NAME } from '@shared/constants';
import { SchoolMeetings } from '../SchoolMeetings';

const Container = styled.div`
  max-width: 360px;
  margin: 0 auto;
  padding: 24px 32px 16px;
  border-radius: 10px;
  background-color: #ffffff;
`;

const MeetingsBookingWidget = ({
  schoolId,
  schoolName,
  schoolPhone,
  schoolTimeZone,
  schoolBookableMeetingKinds,
  isMessageAllowed,
}) => (
  <Container>
    <SchoolMeetings
      schoolId={schoolId}
      schoolName={schoolName}
      schoolTimeZone={schoolTimeZone}
      schoolPhone={schoolPhone}
      schoolBookableMeetingKinds={schoolBookableMeetingKinds}
      isMessageAllowed={isMessageAllowed}
    />
  </Container>
);

MeetingsBookingWidget.propTypes = {
  schoolId: PropTypes.string,
  schoolName: PropTypes.string,
  schoolPhone: PropTypes.string,
  schoolTimeZone: PropTypes.string,
  schoolBookableMeetingKinds: PropTypes.array,
  isMessageAllowed: PropTypes.bool,
};

MeetingsBookingWidget.defaultProps = {
  schoolId: '',
  schoolName: '',
  schoolPhone: '',
  schoolTimeZone: DEFAULT_TIME_ZONE_NAME,
  schoolBookableMeetingKinds: [],
  isMessageAllowed: false,
};

export { MeetingsBookingWidget };
